<template>
    <button type="button" class="btn-cart open-cart">
        <svg class="icon">
            <use xlink:href="/img/front/icons/svgmap.svg#shopping-bag"/>
        </svg>
        <span v-if="type == 'default'" class="text">
            {{ trans("layout.cart") }}
        </span>

        <span v-if="count > 9" class="cart-value mobile">
            9+
        </span>
        <span v-else class="cart-value mobile">
            {{ count }}
        </span>

        <span class="cart-value">
            {{ count }}
        </span>

    </button>
</template>

<script>
import helper from "./../mixins/helper";

export default {
    mixins: [helper],
    components: {

    },
    props: {
        type: {
            default: 'default'
        }
    },
    data() {
        return {
        }
    },
    beforeMount() {
        
    },
    mounted() {
        
    },
    computed: {
        count: function() {
            if (this.isset(this.$store.state.cart.data)) {
                return this.$store.state.cart.data.length;
            } else {
                return 0;
            }
        }
    },
    methods: {
    }
}
</script>
